import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon CopyIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const CopyIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 14 16">
      <path d="M12 4h-2V2a2 2 0 00-2-2H2a2 2 0 00-2 2v8a2 2 0 002 2h2v2a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2zM2 10.5a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h6a.5.5 0 01.5.5v2H6a2 2 0 00-2 2v4.5zM12.5 14a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5h6a.5.5 0 01.5.5z" />
    </Icon>
  )
}
export default CopyIcon
